import {useEffect, useState} from 'react';

const useWindowFocus = () => {
  // Read synchronously rather than in an effect: starting at a hardcoded false
  // and correcting on mount produced a phantom blur -> focus transition, which
  // UserSyncProvider cannot tell from a real alt-tab and would answer with a
  // second /me fetch seconds after the one it already makes on mount. The
  // webapp is only ever rendered in a real browser (the prerender step drives
  // Chromium), so `document` is always there.
  const [focused, setFocused] = useState(() => document.hasFocus());

  useEffect(() => {
    const onFocus = () => setFocused(true);
    const onBlur = () => setFocused(false);

    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);

    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  }, []);

  return focused;
};

export default useWindowFocus;
